/* eslint-disable */
import styles from './index.module.scss'
import data from './data.json'
import Logo from '../../../assets/images/logo.svg'
import whiteLogo from '../../../assets/images/whiteLogo.svg'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { routes } from '../../../routes'
import { useEffect, useState, useContext } from 'react'
import footerText from '../footer/text.json'
import SearchBar from '../../core/SearchBar'
import {
  LangArrows,
  Menu,
  SearchIcon,
  Close,
  RightArrow,
  BackArrow,
  CallCentre,
} from '../../../icons'
import { PageContext } from '../../../context/PageContextProvider'
import ServicesAPI from '../../../api/services'
import ContactAPI from '../../../api/contact'
import Loading from '../../../components/pages/loading'

const Navbar = ({ title }) => {
  const { ChangeLanguage, language, theme, toggleTheme } = useContext(PageContext)
  const location = useLocation()
  const url = window.location.href
  const [load, setLoad] = useState(false)
  const [open, setOpen] = useState(false)
  const [menu, setMenu] = useState(false)
  const [service, setService] = useState(false)
  const [termsOpen, setTermsOpen] = useState(false)
  const [selectedLang, setSelectedLang] = useState(language)
  const [isVisible, setIsVisible] = useState(false)
  const [services, setServices] = useState([])
  const [contact, setContact] = useState([])
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 30)
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    if (menu) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [menu])

  useEffect(() => {
    setSelectedLang(language)
  }, [language])

  const handleLang = (lang) => {
    setSelectedLang(lang)
    ChangeLanguage(lang)
    setIsVisible(false)
    localStorage.setItem('language', lang)
  }

  const usefulLinks = [
    {
      AZ: 'Xəbərlər',
      ENG: 'News',
      RU: 'Новости',
      TR: 'Haberler',
      path: '/useful/news',
    },
    {
      AZ: 'Təlim və Seminarlar',
      ENG: 'Training & Seminars',
      RU: 'Тренинги и семинары',
      TR: 'Eğitim ve Seminerler',
      path: '/useful/training',
    },
    {
      AZ: 'İstehsalat Təqvimi',
      ENG: 'Production Calendar',
      RU: 'Производственный календарь',
      TR: 'Üretim Takvimi',
      path: '/useful/calendar',
    },
    {
      AZ: 'Kalkulyatorlar',
      ENG: 'Calculators',
      RU: 'Калькуляторы',
      TR: 'Hesaplayıcılar',
      path: '/useful/calculator',
    },
    {
      AZ: 'Valyuta məzənnələri',
      ENG: 'Currency Rates',
      RU: 'Курсы валют',
      TR: 'Döviz Kurları',
      path: '/useful/currency',
    },
  ]

  const generateMenu = () => {
    return (
      <ul className={styles.menu}>
        {data.links.map((item) => {
          const isServices = item.includes === '/services'
          const isUseful = item.includes === '/useful'
          const isActive =
            item.path === '/'
              ? location.pathname === '/'
              : location.pathname.includes(item.includes)
          return (
            <li
              key={item.id}
              className={
                isServices
                  ? styles.hasDropdownServices
                  : isUseful
                  ? styles.hasDropdownUseful
                  : ''
              }
            >
              <NavLink
                className={isActive ? styles.active : ''}
                to={item.path}
              >
                {item[language] || item.AZ}
              </NavLink>
              {isServices ? (
                <ul>
                  {services.map((srv, i) => (
                    <li key={`service-${i}`}>
                      <Link to={`/services/${i + 1}`}>{srv[language] || srv.AZ}</Link>
                    </li>
                  ))}
                </ul>
              ) : null}
              {isUseful ? (
                <ul>
                  {usefulLinks.map((linkItem, idx) => (
                    <li key={`useful-${idx}`}>
                      <Link to={linkItem.path}>{linkItem[language] || linkItem.AZ}</Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          )
        })}
      </ul>
    )
  }

  const generateSideMenu = () => {
    return (
      <ul className={styles.sidebar_menu}>
        {data.links.map((item) => (
          <li
            key={item.id}
            onClick={() => {
              if (item.includes === '/services') {
                setService(true)
              } else {
                setMenu(false)
              }
            }}
          >
            {item.includes === '/services' ? (
              <span className={styles.services_trigger}>{item[language] || item.AZ}</span>
            ) : (
              <NavLink to={item.path}>{item[language] || item.AZ}</NavLink>
            )}
            {item.includes === '/services' ? <RightArrow /> : null}
          </li>
        ))}
      </ul>
    )
  }

  const generateServiceMenu = () => {
    return (
      <ul className={styles.service_menu}>
        {services.map((item, i) => (
          <li key={i}>
            <Link
              onClick={() => {
                setMenu(false)
                setService(false)
              }}
              to={`/services/${i + 1}`}
            >
              {item[language] || item.AZ}
            </Link>
          </li>
        ))}
      </ul>
    )
  }

  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = 'BPG | ' + title + ' | A bright future begins here'
    setMenu(false)
  }, [title, url])

  useEffect(() => {
    (async () => {
      const data1 = await ServicesAPI.getCategories()
      const data2 = await ContactAPI.getAll()
      await setServices(data1.data)
      await setContact(data2.data)
      await setLoad(true)
    })()
  }, [])

  return load ? (
    <div className={`${styles.header_container} navbar ${isScrolled ? styles.scrolled : ''}`}>
      <header className={styles.header}>
        <div>
          <div className={styles.first_container}>
            <button
              type="button"
              className={styles.hamburger_btn}
              onClick={() => setMenu(true)}
              aria-label="Menyu"
            >
              <Menu />
            </button>
            <Link to={routes.home.path} className={styles.logo}>
              <img src={theme === 'dark' ? whiteLogo : Logo} alt={data.logo_alt} />
            </Link>
          </div>
          <nav className={styles.navbar}>{generateMenu()}</nav>
          
          {/* Right Action Controls: Theme Switcher & Language Selector */}
          <div className={styles.nav_right_actions}>
            <button
              type="button"
              onClick={() => toggleTheme()}
              className={styles.theme_toggle_btn}
              title={theme === 'dark' ? 'Gündüz rejiminə keç (Light mode)' : 'Gecə rejiminə keç (Dark mode)'}
              aria-label="Mövzunu dəyiş"
            >
              {theme === 'dark' ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e1bc24" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="5" fill="rgba(225, 188, 36, 0.25)" />
                  <line x1="12" y1="1" x2="1" y2="3" />
                  <line x1="12" y1="21" x2="1" y2="23" />
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                  <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                  <line x1="1" y1="12" x2="3" y2="12" />
                  <line x1="21" y1="12" x2="23" y2="12" />
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                  <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#416db4" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="rgba(65, 109, 180, 0.2)" />
                </svg>
              )}
            </button>

            <div
              className={`${styles.language} ${isVisible ? styles.lang_open : ''}`}
              tabIndex="0"
              onClick={() => setIsVisible(!isVisible)}
              onBlur={(e) => {
                if (!e.currentTarget.contains(e.relatedTarget)) {
                  setIsVisible(false)
                }
              }}
            >
              <span className={styles.lang_trigger}>
                <svg className={styles.globe_icon} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
                <strong>{language}</strong>
                <LangArrows
                  className={styles.chevron}
                  style={
                    isVisible
                      ? { transform: 'rotate(-180deg)' }
                      : null
                  }
                />
              </span>
              {isVisible && (
                <ul className={styles.lang_dropdown}>
                  {data.languages.map((item, i) =>
                    item.lang !== language ? (
                      <li
                        onMouseDown={(e) => {
                          e.stopPropagation()
                          handleLang(item.lang)
                        }}
                        key={i}
                      >
                        {item.lang}
                      </li>
                    ) : null,
                  )}
                </ul>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Drawer Overlay */}
      {menu ? (
        <div className={styles.sidebar_overlay} onClick={() => setMenu(false)}>
          <div className={styles.sidebar} onClick={(e) => e.stopPropagation()}>
            <div className={styles.sidebar_header}>
              {service ? (
                <button
                  type="button"
                  className={styles.sidebar_close_btn}
                  onClick={() => setService(false)}
                  aria-label="Geri"
                >
                  <BackArrow />
                </button>
              ) : (
                <button
                  type="button"
                  className={styles.sidebar_close_btn}
                  onClick={() => setMenu(false)}
                  aria-label="Bağla"
                >
                  <Close />
                </button>
              )}
              <Link
                to={routes.home.path}
                className={styles.logo}
                onClick={() => {
                  setMenu(false)
                }}
              >
                <img src={theme === 'dark' ? whiteLogo : Logo} alt={data.logo_alt} />
              </Link>
            </div>
            {service ? generateServiceMenu() : generateSideMenu()}
            {service ? null : (
              <div className={styles.side_extra_container}>
                {/* Qaydalar və Şərtlər */}
                <div className={styles.side_terms_container}>
                  <div
                    className={styles.side_terms_header}
                    onClick={() => setTermsOpen((prev) => !prev)}
                  >
                    <span>{footerText?.term?.[language] || footerText?.term?.AZ || 'Qaydalar və Şərtlər'}</span>
                    <RightArrow
                      className={`${styles.terms_chevron} ${termsOpen ? styles.open : ''}`}
                    />
                  </div>
                  {termsOpen && (
                    <ul className={styles.side_terms_list}>
                      {footerText?.terms?.map((item) => (
                        <li key={item.id}>
                          <Link
                            to={item.path}
                            onClick={() => {
                              setMenu(false)
                            }}
                          >
                            {item[language] || item.AZ}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </div>
  ) : (
    <Loading />
  )
}

export default Navbar
